export default __webpack_public_path__ + "static/media/(10).ea467e18.jpg";